module.exports = __webpack_public_path__ + "img/select-checked.16fb263f.svg";